import Vue from 'vue';
import vueDebounce from 'vue-debounce';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import './styles/bootstrap.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './styles/base.css';
import 'es6-promise/auto';
import VueApollo from 'vue-apollo';
import apolloClient from './vue-apollo';
import router from './router';
import App from './App.vue';
import store from './store';
import States from './constants/states';

Vue.config.productionTip = false;
Vue.use(VueApollo);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(vueDebounce, {
  listenTo: ['input', 'change', 'update'],
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

async function initData(cb) {
  const states = States;
  store.commit('updateStates', states);
  cb();
}

const initApp = () => {
  new Vue({
    apolloProvider,
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
};

initData(initApp);
